<template>
  <div v-loading="showFlag">
    <t-card>
      <div>
        <!-- 製品クローズ選択テーブル -->
        <t-table
          ref="productCloseSelectTable"
          :data="productCloseSelectTable"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          @selection-change="changeSelect"
          border
        >
          <t-table-column type="selection" min-width="55" align="center" />
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <template slot-scope="scope">
              <t-input
                class="cell_input"
                v-if="
                  column.prop === 'odRemarks' &&
                  editCellData(scope.row, scope.column) == 'input'
                "
                :maxLength="column.maxLength"
                v-model="scope.row[column.prop]"
                @blur="changeCellData(scope.row, column.prop)"
                @focus="changeCellDataToNumber(scope.row, column.prop)"
                @input="inputCheck(scope.row, column.prop)"
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
              />

              <t-input
                class="cell_input_custom"
                v-else-if="
                  column.prop === 'odSupplementAmount' &&
                  editCellData(scope.row, scope.column) == 'input'
                "
                :maxLength="column.maxLength"
                v-model="scope.row[column.prop]"
                @blur="changeCellData(scope.row, column.prop)"
                @focus="changeCellDataToNumber(scope.row, column.prop)"
                @input="inputCheck(scope.row, column.prop)"
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
              />

              <t-input-number
                class="cell_input_number"
                v-else-if="
                  editCellData(scope.row, scope.column) == 'inputNumber'
                "
                :controls="false"
                :precision="column.precision || 0"
                :min="0"
                :max="column.max || 999999"
                v-model="scope.row[column.prop]"
                :maxLength="6"
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
              />
              <!-- 支払区分  -->
              <t-select
                v-else-if="column.prop === 'odExPayMethod'"
                v-model="scope.row[column.prop]"
                placeholder=""
                :disabled="
                  !closeDataList.includes(scope.row.odOrderDetailNo) ||
                  scope.row.odPayStatus !== '1'
                "
              >
                <t-option
                  v-for="item in supplementPayMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </t-option>
              </t-select>
              <span v-else>
                {{ scope.row[column.prop] }}
              </span></template
            >
          </t-table-column></t-table
        >
        <t-row>
          <t-col :span="24" class="right">
            <!-- 確定ボタン -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              :disabled="productCloseSelectTable.length == 0"
              @click="confirmClick()"
            >
              <i class="el-icon-check"></i>{{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  getInitInfoListForRestock,
  searchProductNormalInfoByObQuoteNoInOrder,
  updateProductCloseSelectDataInOrder,
} from "@/services/order";
import {
  cmpDetailData,
  formatCurrencyToNumber,
  formatStringToCurrency,
  getDialogContentHeight,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, NUM_TWO, STR_EMPTY } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      //製品クローズ選択テーブル
      productCloseSelectTable: [],

      //製品クローズ選択テーブルの列
      columns: [
        {
          prop: "odProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
        },
        {
          prop: "odProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
        },
        {
          prop: "aodProdQuantity",
          label: t("resource.ORDER.ORDER_QTY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        {
          prop: "odReceQtySum",
          label: t("resource.ORDER.RECE_QTY_SUM"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        {
          prop: "odPayQtySum",
          label: t("resource.ORDER.PAY_QTY_SUM"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        // {
        //   prop: "odPayQuantity",
        //   label: t("resource.ORDER.PAY_QUANTITY"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //   align: "right",
        // },
        {
          prop: "odExPayMethod",
          label: t("resource.ORDER.EX_PAY_METHOD"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_THIRTY"),
          align: "center",
        },

        // 補足金額
        {
          prop: "odSupplementAmount",
          label: t("resource.ORDER.SUPPLEMENT_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },

        {
          prop: "odRemarks",
          label: t("resource.COMMON_CONSTANT.BIKOU"),
          width: t("widgetSize.COMMON_WIDTH.TWO_HUNDRED"),
          align: "left",
          overflowTooltip: true,
        },
      ],

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),
      //支払状態リスト(補足) 1：補足不要  2：補足必要
      supplementPayMethodList: [],

      data: null,

      showFlag: false,

      //クローズ状態のデータ
      closeDataList: [],
    };
  },
  props: {
    obOrderNo: {
      Type: String,
      default: STR_EMPTY,
    },
    obOrderNoShow: {
      Type: String,
      default: STR_EMPTY,
    },
  },
  mounted() {
    this.Init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    Init() {
      this.showFlag = true;
      // 基本情報のリスト取得（異常区分、受注クローズ、支払区分）
      getInitInfoListForRestock()
        .then((res) => {
          // 支払状態リスト  1：不要  2：必要
          res.exPayMethodList.forEach((item) => {
            let supplementNewItem = {
              value: item.DomainKbnVal,
              label: item.Description1,
            };

            //支払状態リスト(補足)に追加
            this.supplementPayMethodList.push(supplementNewItem);
          });

          //明細情報の検索
          this.searchData();
        })
        .catch((err) => {
          this.showFlag = false;

          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }

          //確定ボタンが使用不可に変更
          this.confirmBtn = true;
        });
    },

    searchData() {
      //検索製品クローズ選択情報
      searchProductNormalInfoByObQuoteNoInOrder({
        odOrderNo: this.obOrderNo,
        odOrderNoShow: this.obOrderNoShow,
      })
        .then((res) => {
          //製品クローズ選択テーブル
          this.productCloseSelectTable = res;

          //クローズ状態のデータ
          let filteredItems = this.productCloseSelectTable.filter(
            (item) => item.odCloseState === "1"
          );
          this.closeDataList = filteredItems.map(
            (item) => item.odOrderDetailNo
          );

          //データ処理
          this.dataProcess();
          // console.log(
          //   "this.productCloseSelectTable - " +
          //     JSON.stringify(this.productCloseSelectTable)
          // );
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
    },

    //データ処理
    dataProcess() {
      this.productCloseSelectTable.map((item) => {
        if (!item.odSupplementAmount) {
          item.odSupplementAmount = 0;
        }

        //クローズ状態
        if (item.odCloseState == "1") {
          //クローズ状態をチェックする
          this.$nextTick(() => {
            this.$refs.productCloseSelectTable.toggleRowSelection(item, true);

            item.odSupplementAmount = formatStringToCurrency(
              formatCurrencyToNumber(item.odSupplementAmount)
            );
          });
        }
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extract(this.productCloseSelectTable))
        );
        this.numLoads = this.numLoads + 1;
      }
    },

    //確定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      this.showFlag = true;

      var tmpTableData = this.productCloseSelectTable.map((item) => {
        if (item.odCloseState != "1") {
          item.odSupplementAmount = 0;
          // item.odRemarks = "";
        }
        return {
          ...item,
          //補足金額の変換
          odSupplementAmount: formatCurrencyToNumber(item.odSupplementAmount),
        };
      });

      //製品クローズ選択の更新
      updateProductCloseSelectDataInOrder({
        odOrderNo: this.obOrderNo,
        // productNormalInfoList: this.productCloseSelectTable,
        productNormalInfoList: tmpTableData,
        odOrderNoShow: this.obOrderNoShow,
        loginUser: getUserInfo().UserId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.numLoads = 1;
          this.searchData();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //セルの編集
    editCellData(row, column, cell, event) {
      //「備考」のみ編集可
      if (
        this.closeDataList.includes(row.odOrderDetailNo) &&
        (column.property === "odRemarks" ||
          (column.property === "odSupplementAmount" &&
            row.odExPayMethod == NUM_TWO)) &&
        row.odPayStatus === "1"
      ) {
        return "input";
      }

      //「支払予定数」のみ編集可
      if (
        this.closeDataList.includes(row.odOrderDetailNo) &&
        column.property === "odPayQuantity"
      ) {
        return "inputNumber";
      }

      return false;
    },

    //選択項目の変更
    changeSelect(val) {
      this.closeDataList = val.map((item) => item.odOrderDetailNo);

      this.$nextTick(() => {
        this.productCloseSelectTable.map((item) => {
          if (!this.closeDataList.includes(item.odOrderDetailNo)) {
            item.odCloseState = "0";
          } else {
            item.odCloseState = "1";
          }
          return item;
        });
      });
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //「備考」のみ編集可
      if (
        this.closeDataList.includes(row.odOrderDetailNo) &&
        (column.property === "odRemarks" ||
          column.property === "odPayQuantity" ||
          (column.property === "odSupplementAmount" &&
            row.odExPayMethod == NUM_TWO) ||
          column.property === "odExPayMethod") &&
        row.odPayStatus === "1"
      ) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
      return;
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      //入力ボックスが1つしかない場合
      if (this.closeDataList.length == 1) {
        return;
      }

      index = index + 1;

      if (index > this.productCloseSelectTable.length - 1) {
        for (var i = 0; i < this.productCloseSelectTable.length; i++) {
          if (
            this.$refs[`input${i}-${columnProp}`] !== undefined &&
            this.$refs[`input${i}-${columnProp}`].length !== 0
          ) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;

        for (i; i < this.productCloseSelectTable.length; i++) {
          if (
            this.$refs[`input${i}-${columnProp}`] !== undefined &&
            this.$refs[`input${i}-${columnProp}`].length !== 0
          ) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }

        //下に入力ボックスがない場合は、最初から
        if (i == this.productCloseSelectTable.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },
    //データの変更
    changeCellData(row, column) {
      this.$nextTick(() => {
        row.odSupplementAmount = formatStringToCurrency(
          formatCurrencyToNumber(row.odSupplementAmount)
        );
      });
    },

    changeCellDataToNumber(row, column) {
      if (column === "odRemarks") {
        return;
      }

      this.$nextTick(() => {
        if (!row.odSupplementAmount) {
          row.odSupplementAmount = 0;
        } else {
          row.odSupplementAmount = formatCurrencyToNumber(
            row.odSupplementAmount
          );
        }
      });
    },

    inputCheck(row, column) {
      if (column == "odSupplementAmount") {
        this.$nextTick(() => {
          row[column] = row[column].replace(/[^\d]/g, "");
        });
      }
    },

    //テーブルで変更される可能性のある列の取得
    extract(data) {
      return data.map((item, index) => {
        return {
          index: index,
          odCloseState: item.odCloseState,
          odExPayMethod: item.odExPayMethod,
          odSupplementAmount: item.odSupplementAmount,
          odRemarks: item.odRemarks,
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      var tmpTableData = JSON.parse(
        JSON.stringify(this.extract(this.productCloseSelectTable))
      );

      tmpTableData.map((item) => {
        item.odSupplementAmount = formatCurrencyToNumber(
          item.odSupplementAmount
        );

        return item;
      });

      if (
        !cmpDetailData(
          this.cmpDetailResult,
          JSON.parse(JSON.stringify(this.extract(tmpTableData)))
        )
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.cell_input .el-input__inner {
  height: 25px !important;
  padding: 0 5px !important;
}
</style>

